<template>
    <div class="mainx font-inter d-flex flex-column" style="gap: 24px">
      <div>
        <BaseHeader 
          :title="monthYear 
            ? $t('views.seller.reports.text_1452') + ' de ' + monthYear 
            : $t('views.seller.reports.text_1452')"
          syle=""
        />
        <b-breadcrumb
          :items="[
            { text: 'Dashboard', href: '/dashboard' }, 
            { text: $t('views.seller.reports.text_1428'), href: '/relatorios' }, 
            { text: $t('views.seller.reports.text_1444'), href: '/relatorios/potencial_receita  ' },
            { text: `${$t('views.seller.reports.text_1452')} ${monthYear ? 'de ' + monthYear : ''}` },
          ]"
          class="bg-white m-0 p-0"></b-breadcrumb>
      </div>
      <div class="divider my-0"></div>
      <!-- Filters -->
      <div class="filters d-flex flex-wrap">
        <b-col sm="12" md="2" class="mr-2 mr-md-2 my-2 mx-md-o my-md-0 p-0">
          <div class="multiselect-container p-0">
            <BaseSearchSelect 
              id="product-filter"
              v-model="productsOptions.value"
              :options="productsOptions.items"
              name="product"
              label="name"          
              track-by="id"
              deselect-label=""
              selectLabel=""
              selectedLabel=""
              :placeholder="$t('views.seller.reports.text_1430')"
              :allow-empty="true"
              :multiple="false" 
              :searchable="true"
              :options-limit="50"
              :loading="loadingProducts"
              @search-change="searchProducts"
              class="new-style"
            >
              <span slot="noOptions">
                {{ $t("views.seller.reports.text_1330") }}
              </span>
              <span slot="noResult">
                {{ $t("views.seller.reports.text_1331") }}
              </span>
            </BaseSearchSelect>
          </div>
        </b-col>
        <b-col sm="12" md="1" class="mr-2 mr-md-2 my-2 mx-md-o my-md-0 p-0">
          <BaseSearchSelect
            v-model="filterSearch.monthYear"
            name="monthYear"
            label="name"   
            track-by="id"
            deselect-label=""
            selectLabel=""
            selectedLabel=""
            placeholder="Mês/ano"
            :options="monthYearOptions" 
            :allow-empty="true"
            :searchable="true"
          />
        </b-col>
        <b-col sm="12" md="2" class="mr-2 mr-md-2 my-2 mx-md-o my-md-0 p-0">
          <multiselect 
            v-model="subscriptionStatusOptions.value"
            :options="subscriptionStatusOptions.items" 
            :multiple="true" 
            :taggable="false"
            :show-labels="false" 
            :clear-on-select="false" 
            :close-on-select="false"
            :limit-text="(count) => `+ ${count}`"   
            :limit="2" 
            :group-select="true"
            :select-label="'Select'"
            class="new-style"
            group-values="options"
            group-label="group"
            :placeholder="$t('views.seller.reports.text_1461')" 
            track-by="name"
            label="name"
            @close="(value) => handleApplyFilter('subscriptionStatus', value)"
            @remove="(value) => handleRemoveFilter('subscriptionStatus', value)"
          >
            <template #option="props">
              <span class="option__title" v-if="props.option?.$isLabel">
                {{ props.option.$groupLabel.name }}
                <span class="label-info label-info--deselected">{{ $t('views.seller.integrations.config.save.product.select_all') }}</span>
                <span class="label-info label-info--selected">{{ $t('views.seller.integrations.config.save.product.remove_all') }}</span>
              </span>
              <span class="d-flex option__item" v-else>
                <img :src="isOptionSelected('subscriptionStatusOptions', props.option.id)" />
                {{ props.option.name }}
              </span>
            </template>
            <template #placeholder>
              <span class="select-title">{{ $t('views.seller.reports.text_1461') }}</span>
            </template>
            <span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
            <span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
            <div slot="limit" class="multiselect__tag limit">+{{ subscriptionStatusOptions?.value?.length - 2 }}</div>
            <template #caret>
              <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
            </template>
          </multiselect>
        </b-col>
        <b-col sm="12" md="2" class="mr-2 mr-md-2 my-2 mx-md-o my-md-0 p-0">
          <multiselect 
            v-model="paymentMethodOptions.value"
            :options="paymentMethodOptions.items" 
            :multiple="true" 
            :taggable="false"
            :show-labels="false" 
            :clear-on-select="false" 
            :close-on-select="false"
            :limit-text="(count) => `+ ${count}`"   
            :limit="2" 
            :group-select="true"
            :select-label="'Select'"
            class="new-style"
            group-values="options"
            group-label="group"
            :placeholder="$t('views.seller.reports.text_1457')" 
            track-by="name"
            label="name"
            @close="(value) => handleApplyFilter('paymentMethod', value)"
            @remove="(value) => handleRemoveFilter('paymentMethod', value)"
          >
            <template #option="props">
              <span class="option__title" v-if="props.option?.$isLabel">
                {{ props.option.$groupLabel.name }}
                <span class="label-info label-info--deselected">{{ $t('views.seller.integrations.config.save.product.select_all') }}</span>
                <span class="label-info label-info--selected">{{ $t('views.seller.integrations.config.save.product.remove_all') }}</span>
              </span>
              <span class="d-flex option__item" v-else>
                <img :src="isOptionSelected('paymentMethodOptions', props.option.id)" />
                {{ props.option.name }}
              </span>
            </template>
            <template #placeholder>
              <span class="select-title">{{ $t('views.seller.reports.text_1457') }}</span>
            </template>
            <span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
            <span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
            <div slot="limit" class="multiselect__tag limit">+{{ paymentMethodOptions?.value?.length - 2 }}</div>
            <template #caret>
              <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
            </template>
          </multiselect>
        </b-col>
        <b-col sm="12" md="2" class="mr-2 mr-md-2 my-2 mx-md-o my-md-0 p-0">
          <BaseNewButton
            variant="secondary"
            :disabled="!hasFilterFilled"
            @click.prevent="handleClearFilters"
            style="height: 38px !important;"
          >
            {{ $t("common.text_0003") }}
          </BaseNewButton>
        </b-col>
        <b-col sm="12" md="" class="flex-row-reverse d-flex p-0">
            <BaseNewButton
              variant="primary"
              @click.prevent="$bvModal.show('upcoming-invoices-export')"
            >
              Exportar Tabela
          </BaseNewButton>
		      <UpcomingInvoicesExportModal 
            :filters="{
              ...filterSearch, 
              monthYear: filterSearch.monthYear ? filterSearch.monthYear.id : null,
            }" 
            type="details" 
            :note="recordsLimit && $t('views.seller.reports.text_1469', { maxRecords: recordsLimit })" 
          />
        </b-col>
      </div>

      <div class="container-x">
        <div class="box-stateless">
          <div class="position-relative">
            <TableSummary
              :subtitle="$t('views.seller.reports.text_1453')"
              :subtitle-warning="$t('views.seller.reports.text_1454')"
              :total="salesSummary"
              :subtotal="salesCount">
            </TableSummary>
            <b-skeleton-wrapper :loading="loading" style="top: 0" class="bg-white mt-3 rounded-lg position-absolute d-flex px-4 align-items-end w-100">
              <template #loading>
                <div class="w-100 mb-2">
                  <b-skeleton class="my-2" width="60%"></b-skeleton>
                  <b-skeleton class="mb-2" width="80%"></b-skeleton>
                </div>
                <div class="w-100 mb-2 d-flex align-items-end flex-column">
                  <b-skeleton class="mb-2" width="30%" height="50%"></b-skeleton>
                  <b-skeleton class="mb-1" width="40%" ></b-skeleton>
                </div>
              </template>
            </b-skeleton-wrapper>
          </div>
          <div class="position-relative" style="min-height: 469px;">
            <Table 
              :columns="tableColumns"
              :rows="sales"
              :links="{
                'ID da assinatura': (id) => `/contratos?c_id=${id}`,
              }"
            ></Table>
            <div class="position-absolute w-100 h-100 bg-white" v-if="loading" style="top: 0;">
              <b-skeleton-table
                class="h-100"
                :rows="8"
                :columns="6"
                :table-props="{ bordered: false, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-end" style="border-top: 1px solid #dee2e6; height: 80px; margin-bottom: 10px; ">
            <Paginate
              v-if="sales.length > 0"
              class="mr-4"
              :totalPages="pagination.totalPages"
              :activePage="pagination.currentPage"
              @to-page="toPage"
              @per-page="perPage"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import moment from 'moment-timezone';
  import { Money } from 'v-money';
  
  import Multiselect from 'vue-multiselect';
  import DateRangePicker from 'vue2-daterange-picker';
  
  import _ from 'lodash';
  
  import ReportService from '@/services/resources/ReportService';
  import ProductService from '@/services/resources/ProductService';
  import GlobalSettings from "@/services/resources/GlobalSettings";

  import BaseHeader from '@/components/BaseHeader.vue';
  import Container from '@/components/Seller/Reports/Container.vue';
  import Table from '@/components/Seller/Reports/TableReportRefund.vue';
  import TableSummary from "@/components/Seller/Reports/TableSummary.vue";
  import Paginate from '@/components/shared/Paginate';
  import UpcomingInvoicesExportModal from '@/components/Seller/Reports/modals/UpcomingInvoicesExportModal.vue';
  const globalSettingsService = GlobalSettings.build();

  const Report = ReportService.build();
  const productService = ProductService.build();

  moment.locale('pt-br');
  
  export default {
    components: {
      BaseHeader,
      Container,
      Table,
      Multiselect,
      DateRangePicker,
      Money,
      TableSummary,
      Paginate,
      UpcomingInvoicesExportModal,
    },
    data() {
      return {  
        data: [],
        loading: true,
        loadingProducts: false,
        sales: [],
        productsOptions: {
          value: null,
          items: []
        },
        subscriptionStatusOptions: {
          value: [],
          items: [],
        },
        paymentMethodOptions: {
          value: [],
          items: [],
        },
        monthYearOptions: [], 
        filterSearch: {
          products: [],
          monthYear: null,
          subscriptionStatus: [],
          paymentMethod: []
        },
        monthYear: null,
        salesSummary: "R$ 0",
        salesCount: "0",
        tableColumns: [
          this.$t('views.seller.reports.text_1455'), 
          this.$t('views.seller.reports.text_1456'), 
          this.$t('views.seller.reports.text_1457'), 
          this.$t('views.seller.reports.text_1458'), 
          this.$t('views.seller.reports.text_1459'), 
          this.$t('views.seller.reports.text_1460'), 
        ],
        pagination: {
          totalPages: 1,
          currentPage: 1,
          perPage: 10
        },
        recordsLimit: 0
      };
    },
    computed: {
      hasFilterFilled() {
        return (
          this.filterSearch.products.length > 0 ||
          (this.filterSearch.monthYear && this.filterSearch.monthYear.id !== this.monthYearOptions[0].id )||
          this.filterSearch.subscriptionStatus.length > 0 ||
          this.filterSearch.paymentMethod.length > 0
        );
      },
    },
    watch: {
      ['productsOptions.value']: function (products) {        
        if (products.id)   {
          this.filterSearch.products = [products.id];
        }
      },
      ['filterSearch.monthYear']: function(monthYear) {
        this.monthYear = monthYear.name;
        this.$router.replace({
          query: {
            ...this.$route.query,
            month_year: monthYear.name
          }
        });
      },
      filterSearch: {
        handler: function () {
          this.pagination.currentPage = 1;
          this.fetchData();
        },
        deep: true,
      },
    },
    methods: {
      formatFilters() {
        const filters = { 
          ...this.filterSearch, 
          monthYear: this.filterSearch.monthYear.id 
        };

        if (!filters.subscriptionStatus.length) delete filters.subscriptionStatus;
        if (!filters.paymentMethod.length) delete filters.paymentMethod;

        return filters;
      },
      updateTableData(response) {
        this.salesSummary = response.sales_summary;
        this.salesCount = `Total de Vendas: ${response.sales_count}`;
        this.sales = response.sales;
        this.pagination = {
          currentPage: response.currentPage,
          totalPages: Math.ceil(response.total / response.perPage),
          perPage: response.perPage,
        };
      },
      mapMonthYearOptions(data) {
        return data.map(item => ({
          id: moment(item.month_year, 'MMM/YYYY', 'pt').format('YYYY-MM'),
          name: item.month_year,
        }));
      },
      async fetchData() {
        try {
          this.loading = true;
          const filters = this.formatFilters();

          const response = await Report.search({ 
            url: 'upcoming-invoices/details',
            ...filters,
            page: this.pagination.currentPage,
            per_page: this.pagination.perPage,
          });
          this.updateTableData(response);
        } catch (error) {
          console.error('PotentialRevenue::fetchData', error);
        } finally {
          this.loading = false;
        }
      },
      async fetchMonths() {
        try {
          if (this.monthYearOptions.length > 0) {
            return;
          }
          const response = await Report.search({ 
            url: 'upcoming-invoices',
            type: 'full',
            products: []
          });

          const data = response?.sales_grouped_by_month_table || [];
            
          this.monthYearOptions = this.mapMonthYearOptions(data);
          this.setMonthYearFilter(this.monthYearOptions);
        } catch (error) {
          console.error('PotentialRevenue::fetchMonths', error);
        }
      },
      async fetchProducts(search = null) {
        try {
          this.loadingProducts = true;
          this.productsOptions.items = [];
          const data = {
            list: true,
            with_participants: true,
          };
  
          if (search) {
            data.search = search;
          }
  
          const products = await productService.search(data);
  
          if (!products.length) {
            return [];
          }
          this.productsOptions.items = products.map(({ id, name }) => ({ id, name }));
        } catch (error) {
          this.productsOptions.items = [];
          console.error('PotentialRevenue::fetchProducts', error);
        } finally {
          this.loadingProducts = false;
        }
      },
      searchProducts: _.debounce(async function (search) {
        await this.fetchProducts(search);
      }, 500),
      handleApplyFilter(field, value) {
        const itemValue = value.map(item => item.id);
        this.filterSearch[field] = itemValue;
      },
      handleRemoveFilter(field, value) {
        if (Array.isArray(value)) {
          this.filterSearch[field] = [];
        } 
        if (value && typeof value === 'object') {
          this.filterSearch[field] = this.filterSearch[field].filter(
            (itemValue) => itemValue !== value.id
          );
         }
      },
      handleClearFilters() {
        Object.assign(this.filterSearch, {
          products: [],
          monthYear: this.monthYearOptions[0],
          subscriptionStatus: [],
          paymentMethod: []
        });
  
        this.productsOptions.value = [];
        this.subscriptionStatusOptions.value = [];
        this.paymentMethodOptions.value = [];
      },
      toPage(page) {
        this.pagination.currentPage = page;
        this.fetchData();
      },
      perPage(qtd) {
        this.pagination.currentPage = 1;
        this.pagination.perPage = qtd;
        this.fetchData();
      },
      setMonthYearFilter(monthYearOptions = null) {
        if (!this.monthYear && monthYearOptions) {
          this.filterSearch.monthYear = monthYearOptions[0];
        }

        if (this.monthYear) {
          this.filterSearch.monthYear = {
            id: moment(this.monthYear, 'MMM/YYYY', 'pt').format('YYYY-MM'),
            name: this.monthYear
          }
        }
      },
      isOptionSelected(type, option, force, obj) {
        let object = obj || this[type];
        return object?.value?.find(item => item.id === option) || force
          ? require('@/assets/img/icons/checkbox-area-selected.svg')
          : require('@/assets/img/icons/checkbox-area.svg');
      },
      initializeFilters() {
        this.subscriptionStatusOptions = {
          value: [],
          items: [{
            group: {
              name: this.$t('views.seller.reports.subscription_status.group'),
            },
            options: [
              { id: 'paid', name: this.$t('views.seller.reports.subscription_status.paid') },
              { id: 'waiting_payment', name: this.$t('views.seller.reports.subscription_status.waiting_payment') },
            ],
          }],
        };

        this.paymentMethodOptions = {
          value: [],
          items: [{
            group: {
              name: this.$t('views.seller.reports.text_1457'),
            },
            options: [
              { id: 'credit_card', name: this.$t('views.seller.reports.text_1434') },
              { id: 'boleto', name: this.$t('views.seller.reports.text_1435') },
              { id: 'international', name: this.$t('views.seller.reports.text_1436') },
            ]
          }],
        };

        if (this.$route.query.month_year) {
          this.monthYear = this.$route.query.month_year;
        }
      },
      loadInitialData() {
        Promise.all([this.fetchMonths(), this.fetchProducts(), this.getLimit()])
          .then(() => {
            this.fetchData();
          })
          .catch((error) => {
            console.error('PotentialRevenue::loadInitialData', error);
          });
      },
      async getLimit() {
        const response = await globalSettingsService
          .search({ keys: 'UPCOMING_INVOICES_DETAILS_LIMIT_DATA' });

        const settings = response.find(item => item.key === 'UPCOMING_INVOICES_DETAILS_LIMIT_DATA');

        if (settings) {
          this.recordsLimit = settings.value;
        }
      }
    },
    mounted() {
      this.initializeFilters();
      this.loadInitialData();
    }
  };
  </script>
  
  <style scoped>
  ::v-deep(.new-style .multiselect__tags) {
    margin-top: 0 !important;
  }

  .box-stateless {
    border: 1px solid #D7DAE2;
    box-sizing: border-box;
    border-radius: 8px;
  }
  
  .container-x {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 24px;
  }
  </style>
  <style>
  .box-stateless {
    table thead tr th:first-child {
      border-top-left-radius: 8px;
    }
  
    table thead tr th:last-child {
      border-top-right-radius: 8px;
    }
  }
  </style>